import React from 'react';
import { FaFilePdf, FaVideo } from 'react-icons/fa'; // Using FontAwesome icons
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Import carousel styles

const FileViewer = ({ fileUrls }) => {
  // Function to determine the type of file and return appropriate JSX element
  const renderFile = (fileUrl, index) => {
    const fileExtension = fileUrl.split('.').pop().toLowerCase();

    if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
      // For image files
      return (
        <div key={index} style={styles.fileContainer}>
          <img src={fileUrl} alt={`Image ${index + 1}`} style={styles.image} />
        </div>
      );
    } else if (['mp4', 'webm', 'ogg'].includes(fileExtension)) {
      // For video files
      return (
        <div key={index} style={styles.fileContainer}>
          <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={styles.fileItem}>
            <FaVideo size={30} style={{ marginRight: '10px' }} />
            <span>Video {index + 1}</span>
          </a>
        </div>
      );
    } else if (['pdf'].includes(fileExtension)) {
      // For PDF files
      return (
        <div key={index} style={styles.fileContainer}>
          <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={styles.fileItem}>
            <FaFilePdf size={30} style={{ marginRight: '10px' }} />
            <span>PDF {index + 1}</span>
          </a>
        </div>
      );
    } else {
      return <p key={index}>Unsupported file format: {fileUrl}</p>;
    }
  };

  return (
    <div style={styles.container}>
      <Carousel showThumbs={false} showStatus={false} infiniteLoop>
        {fileUrls?.map((fileUrl, index) => (
          <div key={index}>
            {renderFile(fileUrl, index)}
          </div>
        ))}
      </Carousel>
    </div>
  );
};

// Styles
const styles = {
  container: {
    maxWidth: '800px', // Adjust the max width as needed
    margin: '0 auto',
  },
  fileContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px', // Set a fixed height for consistency
  },
  image: {
    width: '200px',
    height: '200px',
    objectFit: 'cover',
    borderRadius: '4px',
  },
  fileItem: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: '#333',
    fontSize: '16px',
  },
};

// Example usage of the component
const ExampleComponent = ({ fileData }) => {
  return <FileViewer fileUrls={fileData} />;
};

export default ExampleComponent;
